import confetti from "canvas-confetti";

const COLORS = ["#FD0F10", "#F59E0B", "#10B981", "#06B6D4", "#FFFFFF"];

export function celebrate() {
  const end = Date.now() + 1200;
  const frame = () => {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: COLORS });
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: COLORS });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
}

export function bigCelebrate() {
  const duration = 2500;
  const end = Date.now() + duration;
  confetti({ particleCount: 120, spread: 90, origin: { y: 0.6 }, colors: COLORS });
  const frame = () => {
    confetti({ particleCount: 6, angle: 60, spread: 70, origin: { x: 0, y: 0.7 }, colors: COLORS });
    confetti({ particleCount: 6, angle: 120, spread: 70, origin: { x: 1, y: 0.7 }, colors: COLORS });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
}
